<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M34.3906 92.4278L39.9274 101.888C41.4753 104.531 44.8688 105.418 47.5121 103.87L111.179 66.5956C113.822 65.0477 114.709 61.6542 113.161 59.0109L108.643 51.2892C108.101 50.3664 106.982 49.9616 105.975 50.3247C101.51 51.95 96.3902 50.2057 93.9017 45.9608C91.4191 41.716 92.4014 36.3936 96.0033 33.2978C96.8129 32.6012 97.0094 31.4224 96.4676 30.4996L94.0029 26.2905"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M95.5461 28.922L91.6526 22.2779C90.1999 19.7953 87.0088 18.9618 84.5262 20.4144C84.5262 20.4144 24.9854 51.4321 19.6511 58.3977C14.9538 64.5357 19.7046 74.7519 28.8254 73.5017C38.5058 72.1741 44.3878 82.7236 34.3919 92.4278"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M102.131 71.8942L76.668 28.3981"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="4.17 8.33" />
        <path
            d="M57.4255 59.9932C57.4255 59.9932 53.776 48.0267 56.4967 48.3125C59.2175 48.5982 68.368 55.8139 66.7605 59.2371C65.1531 62.6604 60.6046 56.826 69.898 52.2477C79.1855 47.6695 78.4234 50.6403 76.8755 54.516C75.3217 58.3858 67.6178 82.9618 64.1053 81.2591C60.5927 79.5564 63.4861 70.0784 58.6638 69.3759C53.8415 68.6734 47.6022 69.9177 47.9178 66.8874C48.1857 64.3452 52.7401 62.2913 52.7401 62.2913"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M74.042 62.4698C74.042 62.4698 82.4245 68.6555 81.1505 71.15C79.8764 73.6386 72.6191 71.7394 72.6191 71.7394"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
